<ul class="nav nav-tabs pt-3" id="modelTab" role="tablist">
    <li *ngFor="let modelTab of modelTabs; let i = index" class="nav-item" role="presentation">
        <button class="nav-link" [ngClass]="{'active': modelTab.active}" id="tab-{{modelTab.id}}" data-bs-toggle="tab"
                data-bs-target="#model{{modelTab.id}}" type="button" role="tab" aria-controls="home"
                aria-selected="true"
                (click)="modelTabChange(modelTab.id)">{{modelTab.name}}
        </button>
    </li>
    <li class="nav-item" *ngIf="canManage">
        <button class="nav-link" id="tab-new" type="button" (click)="createNewModelTab($event)">New Model
        </button>
    </li>
</ul>
<div class="tab-content" id="modelTabContent">
    <div *ngFor="let modelTab of modelTabs; let i = index" class="tab-pane fade"
         [ngClass]="{'show active': modelTab.active}" id="model{{modelTab.id}}" role="tabpanel"
         aria-labelledby="tab-{{modelTab.id}}">
        <jft-revision-tab-model
                [baseCurrencyCode]="baseCurrencyCode"
                [baseUnitCode]="baseUnitCode"
                [finalBaseAmount]="finalBaseAmount"
                [finalGap]="finalGap"
                [finalGapTotal]="finalGapTotal"
                [currentContractsTotal]="currentContractsTotal"
                [totalVolume]="totalVolume"
                [selectedContractsTotal]="selectedContractsTotal"
                [selectedTotalVolume]="selectedTotalVolume"
                [hasSelectedBids]="hasSelectedBids"
                [modelTab]="modelTab"
                (onTabTextChange)="modelTabTextChange($event)">
        </jft-revision-tab-model>
    </div>
</div>
